import * as React from "react";
import { styled } from "@mui/material/styles";
import { useState, useEffect, useRef } from "react";
import {
  Box,
  CssBaseline,
  Toolbar,
  Typography,
  IconButton,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Drawer from "../Drawer/Drawer";
import AppBar from "../Appbar/AppBar";
import { Outlet, useLocation } from "react-router-dom";
import { NestedList } from "../List/List";
import { theme } from "../../../Theme/index";
import RightBar from "../Rightbar/RightBar";
import Marketeers from "../../../Assets/MarketeersLogo.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import PrimaryButton from "../../shared/shared/PrimaryButton";
import { setSelectedFilter } from "../../../Redux/filterSlice/filterSlice"; // 🆕 Import Redux action
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom"; // ✅ Import useNavigate
import { setCurrentChartType } from "../../../Redux/chartSlice/chartSlice"; // ✅ Reset Chart Type
import {
  setAllMarketSelected,
} from "../../../Redux/handleAllMarket/handleAllMarket";
import smartbot1Image from "src/Assets/smartbot1.png";
import TourGuide from "../../TourGuide/TourGuide";


const ContentWrapper = styled("div")(() => ({
  paddingTop: "65px", // Adjust according to your header height
}));

// Route pathname to page title 
const ROUTE_PAGE_TITLES = {
  "/dashboard": "Performance",
  "/gaps-solution": "Diagnostics Analysis",
  "/pricing-architecture": "Pricing",
  "/promotion-visibility": "Promotions",
  "/assortment": "PPA & Assortment",
  "/smart-simulator": "Smart Market Simulator",
  "/optimization": "Optimization",
  "/canvas": "Canvas",
  "/AI-Assistant": "SmartBot",
  "/market-dynamics": "Market Dynamics",
  "/trade-management": "Trade Management",
  "/statistics-test": "Statistics Test",
  "/scenario-builder": "Scenario Builder",
  "/promo-simulator": "Promo Simulator",
  // "/data-center-hub": "Data Center Hub",
  "/select-user-id": "Select Project",
  "/category-edit": "Edit Category",
};

function getPageTitleFromPath(pathname) {
  return ROUTE_PAGE_TITLES[pathname] ?? (pathname === "/" ? "Performance" : "Marketeers");
}

export default function Navbar() {
  const location = useLocation();
  const drawerWidth = useMediaQuery(theme.breakpoints.down("sm")) ? 150 : 200;
  const navigate = useNavigate(); // ✅ Initialize navigation

  const pageTitle = getPageTitleFromPath(location.pathname);
  useEffect(() => {
    localStorage.setItem("page", pageTitle);
  }, [pageTitle]);

  const DrawerHeader = styled("div")(({ theme }) => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: drawerWidth,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "65px",
    padding: theme.spacing(0, 1),
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
  }));

  const [open, setOpen] = useState(true);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));
  const dispatch = useDispatch();
  const drawerRef = useRef(null);
  const isFreeTrial = localStorage.getItem("role") === "free_trial";

  const setPage = (value) => {
    localStorage.setItem("page", value);
  };


  // useEffect(() => {
  //   async function fetchCategories() {
  //     try {
  //       const response = await fetch(`${getUrl()}/market_overview/hierarchy`, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ project_id: projectId }),
  //       });

  //       if (!response.ok) throw new Error("Failed to fetch categories");

  //       const data = await response.json();

  //       if (!data["1"]) {
  //         console.error("No data for key '1' found in response.");
  //         return;
  //       }

  //       // Extract categories dynamically
  //       const formattedOptions = data["1"]
  //         ? Object.entries(data["1"]).flatMap(([category, values]) =>
  //             values.map((value) => ({ category, name: value }))
  //           )
  //         : [];

  //       setCategories(formattedOptions);
  //     } catch (error) {
  //       console.error("Error fetching categories:", error);
  //     }
  //   }

  //   if (projectId) {
  //     fetchCategories();
  //   }
  // }, [projectId]); // ✅ Ensure API runs when `projectId` is available

  useEffect(() => {
    if (!isTablet) {
      handleDrawerOpen();
    }
  }, [isTablet]);

  // Close drawer when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open && isTablet && drawerRef.current && !drawerRef.current.contains(event.target)) {
        const menuButton = document.querySelector('[aria-label="open drawer"]');
        if (menuButton && !menuButton.contains(event.target)) {
          handleDrawerClose();
        }
      }
    };

    if (open && isTablet) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [open, isTablet]);

  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  const outletStyle = {
    flexGrow: 1,
    p: isTablet ? 1 : 3,
    bgcolor: "#FAFBFC",
    marginTop: isTablet ? "50px" : "55px",
    width: "100%",
    maxWidth: "100vw",
    overflowX: "hidden",
    transition: "margin-left 0.3s ease",
    marginLeft: open && !isMobile ? `${drawerWidth}px` : "0px",
  };

  // Function to apply selected filters
  // const handleApplyFilters = () => {
  //   dispatch(setSelectedFilter(tempFilters));
  // };

  return (
    <Box sx={{ display: "flex", width: "100vw", overflowX: "hidden" }}>
      <TourGuide />
      <CssBaseline />
      <AppBar 
      position="fixed" 
      open={open} 
      height="65px" 
      elevation={0}
      sx={{
        width: open && !isMobile ? `calc(100% - ${drawerWidth}px)` : "100%",
        zIndex: theme.zIndex.drawer + 1, 
      }}
      >
        <Toolbar
          sx={{
            minHeight: "65px",
            justifyContent: "space-between", // Pushes items to opposite ends
            paddingX: isTablet ? "5px" : "24px",
            gap: 2,
          }}
        >
          {/* 🔎 Left Section: Menu Icon + Page Title */}
          <Box display="flex" flexDirection="row" alignItems="center" gap={{ xs: 1, sm: 2 }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: { xs: 1, sm: 2 },
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
            </IconButton>
            {pageTitle === "SmartBot" ? (
            <img
              src={smartbot1Image}
              alt="SmartBot"
              style={{
                width: "200px",
                height: "auto",
                objectFit: "contain",
              }}
            />
          ) : (
            <Typography
              variant="h1"
              fontWeight={theme.typography.fontWeightSemiBold}
              noWrap
              sx={{ fontSize: { xs: "14px", sm: "18px", md: "20px" },}}
            >
              {pageTitle}
            </Typography>
          )}

          </Box>

          {/* 🔹 Middle Section: Filters */}
          {/*
          <Box
            display="flex"
            alignItems="center"
            gap={2}
            flexGrow={1}
            justifyContent="center"
          >
            <FilterComponent />
          </Box>
          */}
          {!isFreeTrial && (
            <Box>
              <Typography
                color="text.secondary"
                sx={{
                  mt: { xs: 1, sm: 2 },
                  display: "block",
                  fontSize: { xs: "11px", sm: "15px", md: "17px" },
                  textAlign: "center",
                }}
              >
                Last Data Update: {"31 December 2024"}
              </Typography>
            </Box>
          )}

          {/* 🔹 Right Section: Select Project & RightBar */}
          <Box display="flex" alignItems="center">
            <span data-tour="select-project">
            <PrimaryButton
              onClick={() => {
                dispatch(setSelectedFilter([])); // ✅ Reset selected filters in Redux
                dispatch(setCurrentChartType(null)); // ✅ Reset chart type selection in Redux
                dispatch(setAllMarketSelected(false)); // Toggle between true/false
                navigate("/select-user-id"); // ✅ Navigate to the project selection page
              }}
            >
              Select Project
            </PrimaryButton>
            </span>
            <RightBar />
          </Box>
        </Toolbar>
      </AppBar>

      {/* 📝 Sidebar Drawer */}
      <Drawer
        ref={drawerRef}
        variant="permanent"
        open={open}
        PaperProps={{ 'data-tour': 'sidebar' }}
        sx={{
          display: open || !isMobile ? "block" : "none",
          "& .MuiDrawer-paper": {
            width: isMobile ? "60vw" : drawerWidth,
            maxWidth: "80vw",
            borderWidth: 0,
          },
        }}
      >
        <DrawerHeader>
          {open && (
            <img
              src={Marketeers}
              alt="Marketeers Logo"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          )}
          {open && isTablet && (
            <IconButton onClick={handleDrawerClose}>
              <ChevronRightIcon />
            </IconButton>
          )}
        </DrawerHeader>

        <ContentWrapper>
          <NestedList open={open} setTitle={setPage} />
        </ContentWrapper>
      </Drawer>

      {/* 📝 Main Content */}
      <Box component="main" data-tour="main-content" sx={outletStyle}>
        <Outlet />
      </Box>
    </Box>
  );
}
